import { Models } from '@rematch/core';

/* ENTITIES */
import { usersEntity, storeName as usersEntityName } from './entities/users.entity';
import { rolesEntity, storeName as rolesEntityName } from './entities/roles.entity';
import {
  permissionsEntity,
  storeName as permissionsEntityName,
} from './entities/permissions.entity';
import { tenantsEntity, storeName as tenantsEntityName } from './entities/tenants.entity';

/* MODELS */
import { layoutModel, storeName as layoutModelName } from './models/layout.model';
import { userModel, storeName as userModelName } from './models/user.model';
import { usersModel, storeName as usersModelName } from './models/users.model';
import { rolesModel, storeName as rolesModelName } from './models/roles.model';
import {
  verificationTokenModel,
  storeName as verificationTokenModelName,
} from './models/verificationToken.model';
import { tenantsModel, storeName as tenantsModelName } from './models/tenants.model';

export interface RootModel extends Models<RootModel> {
  /* ENTITIES */
  [usersEntityName]: typeof usersEntity;
  [rolesEntityName]: typeof rolesEntity;
  [permissionsEntityName]: typeof permissionsEntity;
  [tenantsEntityName]: typeof tenantsEntity;
  /* MODELS */
  [layoutModelName]: typeof layoutModel;
  [userModelName]: typeof userModel;
  [usersModelName]: typeof usersModel;
  [rolesModelName]: typeof rolesModel;
  [verificationTokenModelName]: typeof verificationTokenModel;
  [tenantsModelName]: typeof tenantsModel;
}

export const models: RootModel = {
  /* ENTITIES */
  [usersEntityName]: usersEntity,
  [rolesEntityName]: rolesEntity,
  [permissionsEntityName]: permissionsEntity,
  [tenantsEntityName]: tenantsEntity,
  /* MODELS */
  [layoutModelName]: layoutModel,
  [userModelName]: userModel,
  [usersModelName]: usersModel,
  [usersModelName]: usersModel,
  [rolesModelName]: rolesModel,
  [verificationTokenModelName]: verificationTokenModel,
  [tenantsModelName]: tenantsModel,
};
